import Widget from './Widget.component';

export default Widget;
